import { HttpErrorResponse, HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { catchError, throwError } from "rxjs";
import { AlertService } from "../services/alert.service";
import { AuthService } from "../services/auth.service";

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
    const router = inject(Router);
    const alertService = inject(AlertService);
    const authService = inject(AuthService);

    return next(req).pipe(
        catchError((error) => {
            let errorMessage = "Something went wrong";

            if (error instanceof HttpErrorResponse) {
                if (error.status === 401) {
                    errorMessage = "Unauthorized access. Please login again.";
                    authService.logout();
                    router.navigateByUrl("authentication/login");
                } else if (error.status === 500) {
                    errorMessage = error.error?.message || "Something went wrong";
                } else {
                    errorMessage = error.error?.message || error.error || error.message || errorMessage;
                }

                alertService.openSnackBar(errorMessage);
                return throwError(() => error.error);
            }

            alertService.openSnackBar(error.message || errorMessage);
            return throwError(() => error.message);
        }),
    );
};
